import { Component, OnInit } from '@angular/core';
import { AppConfig } from 'app/app.config';

@Component({
  selector: 'Teranet-TermsAndConditionsDialog',
  templateUrl: './terms-and-conditions-dialog.component.html'
})

export class TermsAndConditionsDialogComponent implements OnInit {
  phoneNumber: number;
  emailGeneralQuestion: string;
  emailSalesMarket: string;
  ngOnInit() {
    this.emailGeneralQuestion = AppConfig.settings.settings.Email_General_Question;
    this.emailSalesMarket = AppConfig.settings.settings.Email_Sales_Market;
  }
}
